import React from 'react';
import { Box, Typography, Button } from '@mui/material';

export default function PaneEmpty() {
  return (
    <Box
      sx={{ p: 3, height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
    >
      <Box sx={{ textAlign: 'center' }}>
        <Typography variant="h6" gutterBottom>
          Select content for this pane
        </Typography>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          Use the small tune icon in the top-right of this pane to choose a page, or right-click a
          tab and select “Open in Split”.
        </Typography>
        <Button
          size="small"
          variant="outlined"
          onClick={() => {
            try {
              globalThis.dispatchEvent(
                new CustomEvent('wb:open-in-pane', { detail: { path: '/patient-management' } })
              );
            } catch (e) {
              /* noop */
            }
          }}
        >
          Open Worklist
        </Button>
      </Box>
    </Box>
  );
}
